import { render, staticRenderFns } from "./setUser.vue?vue&type=template&id=09f009e0&scoped=true&"
import script from "./setUser.vue?vue&type=script&lang=js&"
export * from "./setUser.vue?vue&type=script&lang=js&"
import style0 from "./setUser.vue?vue&type=style&index=0&id=09f009e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f009e0",
  null
  
)

export default component.exports